import { useQuery } from '@apollo/client'
import { Button, Modal } from 'antd'
import { uniqBy } from 'lodash'
import React, { useState } from 'react'
import { INTERVENTIONS_ALL_QUERY, INTERVENTIONS_QUERY } from '../../apollo/query/interventions.query'
import { D4_Interventiondemande } from '../../types'
import InterventionsTable from '../InterventionsTable'
import InterventionsAllTable from '../InterventionsTable/InterventionsAllTable'

const InterventionsModal = ({
  equipementId,
  typeequipementId,
  trigramme,
}: {
  equipementId: number
  typeequipementId: number
  trigramme: string
}) => {
  const { data } = useQuery<{ interventions: D4_Interventiondemande[] }, { typeequipementId: number; trg: string }>(
    INTERVENTIONS_QUERY,
    {
      variables: {
        typeequipementId: typeequipementId,
        trg: trigramme,
      },
      skip: !trigramme || !typeequipementId,
    }
  )

  const { data: dataAll } = useQuery<{ interventions: D4_Interventiondemande[] }, { typeequipementId: number }>(
    INTERVENTIONS_ALL_QUERY,
    {
      variables: {
        typeequipementId: typeequipementId,
      },
      skip: !typeequipementId,
    }
  )

  const [visible, setVisible] = useState(false)

  return (
    <div>
      <Modal
        title="Dernières interventions"
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[]}
        width="100%"
      >
        <InterventionsTable
          title="Sur cette copropriété"
          interventions={uniqBy(data?.interventions, 'fournisseur.id') ?? []}
          typeequipementId={typeequipementId}
          equipementId={equipementId}
          trigramme={trigramme}
        />

        <InterventionsAllTable
          title="Sur d'autres copropriétés"
          interventions={uniqBy(dataAll?.interventions, 'fournisseur.id') ?? []}
          typeequipementId={typeequipementId}
          equipementId={equipementId}
          trigramme={trigramme}
        />
      </Modal>

      <Button type="link" onClick={() => setVisible(true)}>
        Voir les dernières interventions
      </Button>
    </div>
  )
}
export default InterventionsModal
